"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.typographyDefault = exports.letterSpacingDenominator = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = require("styled-components");

var _types = require("../types");

function _templateObject10() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n      color: ", ";\n      font-weight: ", ";\n      ", "\n    "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    ", "\n  "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n      color: ", ";\n      font-weight: ", ";\n      ", "\n    "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    ", "\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n      color: ", ";\n      font-weight: ", ";\n      ", "\n    "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    ", "\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n      color: ", ";\n      font-weight: ", ";\n      ", "\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    ", "\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n      color: ", ";\n      font-weight: ", ";\n      ", "\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    ", "\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var letterSpacingDenominator = {
  s: 32,
  m: 16,
  l: 8,
  xl: 4,
  none: 1
};
exports.letterSpacingDenominator = letterSpacingDenominator;
var typographyDefault = {
  headingLarge: (0, _styledComponents.css)(_templateObject(), function (p) {
    return (0, _styledComponents.css)(_templateObject2(), p.theme.colors.onBackground, _types.FontWeights.bold, p.theme.responsiveStyle("font-size", {
      s: "46px",
      m: "52px"
    }));
  }),
  headingMedium: (0, _styledComponents.css)(_templateObject3(), function (p) {
    return (0, _styledComponents.css)(_templateObject4(), p.theme.colors.onBackground, _types.FontWeights.bold, p.theme.responsiveStyle("font-size", {
      s: "20px",
      m: "34px"
    }));
  }),
  headingSmall: (0, _styledComponents.css)(_templateObject5(), function (p) {
    return (0, _styledComponents.css)(_templateObject6(), p.theme.colors.onBackground, _types.FontWeights.bold, p.theme.responsiveStyle("font-size", {
      s: "16px",
      m: "20px"
    }));
  }),
  bodyText: (0, _styledComponents.css)(_templateObject7(), function (p) {
    return (0, _styledComponents.css)(_templateObject8(), p.theme.colors.onBackground, _types.FontWeights.normal, p.theme.responsiveStyle("font-size", {
      s: "12px",
      m: "16px"
    }));
  }),
  buttonText: (0, _styledComponents.css)(_templateObject9(), function (p) {
    return (0, _styledComponents.css)(_templateObject10(), p.theme.colors.onPrimary, _types.FontWeights.bold, p.theme.responsiveStyle("font-size", {
      s: "12px",
      m: "16px"
    }));
  })
};
exports.typographyDefault = typographyDefault;